// src/games/pacman-Muddy/systems/AudioSystem.ts
import {
  AudioSystem as SharedAudioSystem,
  AudioConfig,
} from '../../../engine/ecs/systems/AudioSystem';
import { ResourceManager } from '../../../engine/resources/ResourceManager';

// Muddy-specific audio configuration
const MUDDY_AUDIO_CONFIG: AudioConfig = {
  // superpowerBackgroundMusic: 'super_power_background.wav', // No longer needed - default matches!
  soundVolume: 0.7, // Slightly louder for muddy theme
  musicVolume: 0.5,
  enableSuperpowerMusic: true,
  enableSoundEffects: true,
  enableBackgroundMusic: true,
};

export class AudioSystem extends SharedAudioSystem {
  constructor(resourceManager: ResourceManager) {
    super(resourceManager, MUDDY_AUDIO_CONFIG);
  }
}
